import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { BLOCKS, Document, INLINES } from "@contentful/rich-text-types";
import { assetRenderer } from "components/Accessories/Contentful/AssetRenderer";
import { inlinesHandler } from "components/Accessories/Contentful/InlinesHandler";
import { headingAnchorRenderer } from "components/Accessories/Contentful/HeadingAnchorRenderer";
import { tableRenderer } from "components/Accessories/Contentful/TableRenderer";
import { styles } from "./RichTextWrapper.style";
import { TModuleTextWithImageFields } from "@carfax/contentful/types/wrappers";
import { cx } from "../../../../../../styled-system/css";

interface Props {
  content: Document;
  textAlign?: TModuleTextWithImageFields["textAlign"];
  className?: string;
}

const RichTextWrapper: React.FC<Props> = ({ content, textAlign, className }) => {
  const options = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: assetRenderer.renderImage,
      [INLINES.HYPERLINK]: inlinesHandler.renderHyperlink,
      [BLOCKS.HEADING_2]: headingAnchorRenderer.H2WithAnchor,
      [BLOCKS.HEADING_3]: headingAnchorRenderer.H3WithAnchor,
      [BLOCKS.TABLE]: tableRenderer.renderTable,
    },
  };
  return (
    <div
      className={cx(styles.content({ textAlign }), className)}
      style={{ "--rich-text-wrapper-text-align": textAlign } as React.CSSProperties}
    >
      {documentToReactComponents(content, options)}
    </div>
  );
};

export default RichTextWrapper;
